package com.sddamico.draftmachine.pages

import androidx.compose.runtime.Composable
import com.sddamico.draftmachine.components.layouts.LoadingFrame
import com.sddamico.draftmachine.components.pwa.InstallPrompt
import com.sddamico.draftmachine.components.sections.MachineRoomSection
import com.sddamico.draftmachine.components.sections.PitchSection
import com.sddamico.draftmachine.models.MeResponse
import com.sddamico.draftmachine.util.LoadState
import com.sddamico.draftmachine.util.rememberAuthState
import com.sddamico.draftmachine.util.rememberDashboard
import com.sddamico.draftmachine.util.transitionTo
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext

@Page
@Composable
fun HomePage() {
  val ctx = rememberPageContext()
  val auth = rememberAuthState()

  when (val s = auth.value) {
    is LoadState.Loading -> LoadingFrame()
    // Any unexpected failure falls back to the public pitch (the safe default for a home route).
    is LoadState.Failed -> PitchSection { ctx.router.transitionTo("/login") }
    is LoadState.Ready -> {
      val user = s.value
      if (user == null) {
        PitchSection { ctx.router.transitionTo("/login") }
      } else {
        MachineRoom(
          user = user,
          onStartDraft = { ctx.router.transitionTo("/draft/new") },
          onOpenDraft = { draftId -> ctx.router.transitionTo("/draft/$draftId") },
          onAccount = { ctx.router.transitionTo("/settings") },
          onLeagueSettings = { leagueId -> ctx.router.transitionTo("/league/$leagueId/settings") },
        )
        InstallPrompt()
      }
    }
  }
}

/**
 * The authenticated home (frames 1f / 1g). Loads the caller's dashboard and renders the Machine
 * room; a failed load falls back to the empty state so the chrome and "Start a draft" path remain.
 */
@Composable
private fun MachineRoom(
  user: MeResponse,
  onStartDraft: () -> Unit,
  onOpenDraft: (String) -> Unit,
  onAccount: () -> Unit,
  onLeagueSettings: (String) -> Unit,
) {
  when (val d = rememberDashboard()) {
    is LoadState.Loading -> LoadingFrame()
    is LoadState.Failed -> MachineRoomSection(user.email, emptyList(), onStartDraft, onOpenDraft, onAccount, onLeagueSettings)
    is LoadState.Ready -> MachineRoomSection(user.email, d.value, onStartDraft, onOpenDraft, onAccount, onLeagueSettings)
  }
}
